import MenuItem from '@mui/material/MenuItem';
import CustomSelect from './SelectField';

interface option {
  name: string | number;
  value: string | number;
}
interface IProps {
  options: option[];
  filter: string;
  setFilter: React.Dispatch<React.SetStateAction<string>>;
  label?: string;
}

const StateFilter = ({
  options,
  filter,
  setFilter,
  label = 'Filter',
}: IProps) => {
  return (
    <CustomSelect
      name="filter"
      onChange={(e: any) => setFilter(e.target.value)}
      value={filter}
      variant="filled"
      label={label}
    >
      <MenuItem value="">None</MenuItem>
      {options.map((option) => (
        <MenuItem value={option.value} key={option.name}>
          {option.name}
        </MenuItem>
      ))}
    </CustomSelect>
  );
};

export default StateFilter;
